import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Loaning, Scan} from './loaning.model';
import {LoaningState} from './loaning-states.enum';
import {formatDate} from '@angular/common';
import {finalize, map, tap} from "rxjs/operators";
import * as FileSaver from "file-saver";

@Injectable({
  providedIn: 'root'
})
export class LoaningService extends DaoGeneric<Loaning> {
  private url = `${environment.baseUrl}/api_archive/loaning/`;
  private urlScan = `${environment.baseUrl}/api_archive/scan/`;

  private state: string[] = [];
  constructor(@Inject(LOCALE_ID) private locale: string,
              private httpClient: HttpClient) {
    super(httpClient);
    this._initLabelStatus();
  }

  getRootUrl(): string {
    return this.url;
  }
  getChipButton(loaning: Loaning): string {
    return this.getChipButtonByState(loaning);
  }
  getChipButtonByState(loaning: Loaning) {
    const stateLabel = this.displayStateNames(loaning.status);
    const classType = this.getClassColorBtnChip(loaning.status);
    return `<small><span class="state-consultation-chip ${classType}">${stateLabel}</span></small>`;
  }
  displayStateNames(enumState: number) {
    return this.state[enumState];
  }
  getClassColorBtnChip(status: LoaningState) {
    return `btn-${this.getClassColor(status)}`;
  }
  getClassColor(status: LoaningState) {
    let classe = '';
    switch (status) {
      case LoaningState.DRAFT:
        classe = 'consultation-draft';
        break;
      case LoaningState.WAITING:
        classe = 'consultation-waiting';
        break;
      case LoaningState.IN_PROGRESS:
        classe = 'consultation-in-progress';
        break;
      case LoaningState.DONE:
        classe = 'consultation-done';
        break;
      default :
        classe = '';
    }
    return classe;
  }
  getDateFr(date: string, messageNone = '') {
    if (date) {
      const _formatDate = formatDate(`${date}`, 'dd/MM/yyyy', this.locale);
      return `<strong>${_formatDate}</strong>`;
    } else {
      return messageNone;
    }
  }
  private _initLabelStatus() {
    this.state[LoaningState.DRAFT] = 'En création';
    this.state[LoaningState.WAITING] = 'En attente de traitement';
    this.state[LoaningState.IN_PROGRESS] = 'En cours de traitement';
    this.state[LoaningState.DONE] = 'Fini';
  }


  public exportConsultationPdf(loaning: Loaning) {
    const url = `${this.url}${loaning.uuid}/export_loaning_pdf/`;
    return this.httpClient.get(url, {
      responseType: 'blob'
    }).pipe(map((data: any) => new Blob([data])));
  }

  public uploadScanConsultation(files) {
    const formData: FormData = new FormData();
    formData.append('loaning', files[0].loaning.toString());
    files.forEach((item) => {
      formData.append('files', item.file, item.file.name);
    });
    const urlScan = `${environment.baseUrl}/api_archive/scan/upload_scans/`;
    return this.httpClient.post<any>(urlScan, formData);
  }

  exportZipScansConsultation(loaning: Loaning) {
    const urlDownloadZip = `${this.url}${loaning.uuid}/get_scans_zip/`;
    return this.httpClient.get(urlDownloadZip, { responseType: 'blob' });
  }

  getLoaningById(idLoaning: number) {
    return this.httpClient.get<Loaning>(`${this.url}${idLoaning}/`);
  }

  getFile(id: number) {
    const url = `${this.urlScan}${id}/download_pj/`;
    return this.httpClient.get<Blob>(url, {
      params: {id: `${id}`},
      responseType: 'blob' as 'json'
    });
  }

  downloadSingleScan(scan: Scan) {
    return this.getFile(scan.id).pipe(
      tap((data: Blob) => {
        FileSaver.saveAs(data, scan.file_name);
      })
    );
  }

  deleteFile(fileId: number) {
    const url = `${this.urlScan}${fileId}/`;
    return this.httpClient.delete(url);
  }

}
